import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BarChart } from "lucide-react";

export const TrackingSection = ({ settings, onInputChange }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <BarChart className="w-5 h-5" />
        Tracking & Analytics
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="facebook_pixel_id">Facebook Pixel ID</Label>
        <Input
          id="facebook_pixel_id"
          value={settings.facebook_pixel_id}
          onChange={(e) => onInputChange("facebook_pixel_id", e.target.value)}
          placeholder="123456789012345"
        />
        <p className="text-xs text-muted-foreground">Exemple : 123456789012345</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="google_analytics_id">Google Analytics ID (GA4)</Label>
        <Input
          id="google_analytics_id"
          value={settings.google_analytics_id}
          onChange={(e) => onInputChange("google_analytics_id", e.target.value)}
          placeholder="G-XXXXXXXXXX"
        />
        <p className="text-xs text-muted-foreground">Exemple : G-XXXXXXXXXX</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="google_tag_manager_id">Google Tag Manager ID</Label>
        <Input
          id="google_tag_manager_id"
          value={settings.google_tag_manager_id}
          onChange={(e) => onInputChange("google_tag_manager_id", e.target.value)}
          placeholder="GTM-XXXXXXX"
        />
        <p className="text-xs text-muted-foreground">Exemple : GTM-XXXXXXX</p>
      </div>
    </CardContent>
  </Card>
);
